import fetch from '@/utils/request'

const request = (rest = {}) => fetch({ ...rest, privateFlag: true })
export default {
  // 保存产品控制配置
  addConfigList(data) {
    return request({
      url: `/business/drugControl/save`,
      method: 'POST',
      data
    })
  },
  // 获取产品多人配置列表
  getConfigList(data) {
    return request({
      url: '/business/drugControl/list',
      method: 'POST',
      data,
      privateFlag: true
    })
  },
  // 编辑产品控制配置
  editConfigData(data) {
    return request({
      url: `/business/drugControl/update`,
      method: 'POST',
      data
    })
  },
  // 删除产品控制配置
  deleteConfigData(data) {
    return request({
      url: `/business/drugControl/delete`,
      method: 'POST',
      data
    })
  }
}
